import { useAuth } from '../auth'
import { ofetch } from 'ofetch'
import type { $Fetch } from './fetchType'
import { APP_ENV, api } from '@my/config'
import { PlaidLinkOnSuccess, PlaidLinkOnSuccessMetadata, usePlaidLink } from 'react-plaid-link'
import { useCallback, useState, useEffect } from 'react'
import { localizationHeaders } from './localization'

const examplePlaidAccountsWithBalances = [
  {
    account_id: 'ZZJqbeaYyXF16x6j80Y3INZPovyar0CkmKp4X',
    balances: {
      available: 1419.95,
      current: 1419.95,
      iso_currency_code: 'USD',
      limit: null,
      unofficial_currency_code: null,
    },
    mask: '3051',
    name: 'TOTAL CHECKING',
    official_name: null,
    persistent_account_id: '7a7c6a72867c9d1bcccff8b6fbc6067720654b5b2632a5e7a51123a5',
    subtype: 'checking',
    type: 'depository',
  },
]

interface PlaidReturnType extends Omit<PlaidLinkOnSuccessMetadata, 'accounts'> {
  accounts: typeof examplePlaidAccountsWithBalances
}

export const useAuthedRequestFn = () => {
  const { getToken, userId } = useAuth()
  const authedOfetch = async (request, options) => {
    return ofetch.create({
      baseURL: api.API_URL, // APP_ENV.TZA_BACKEND_API_URI,
      headers: { Authorization: `Bearer ${await getToken()}`, ...localizationHeaders },
      params: APP_ENV.TZA_ENV === 'development' ? { userId } : {},
    })(request, options)
  }
  return authedOfetch as $Fetch
}

export const useAuthedPlaidLink = (options: {
  onSuccess: (plaidData: PlaidReturnType) => void
}) => {
  const { userId } = useAuth()
  const authedRequestFn = useAuthedRequestFn()
  const [token, setToken] = useState<string | null>(null)
  const site_origin = window?.location?.origin
  // get link_token from your server when component mounts
  useEffect(() => {
    const createLinkToken = async () => {
      const response = await authedRequestFn('plaid/create_link_token', {
        method: 'POST',
        body: { userId, site_origin },
      })
      const { link_token } = await response
      setToken(link_token)
    }
    createLinkToken()
  }, [])

  /* const linkToken = useClerkQuery('plaid/create_link_token', { method: 'POST', body: { userId, site_origin }});
  console.log({linkToken}) */

  const onSuccess = useCallback<PlaidLinkOnSuccess>((publicToken, metadata) => {
    // send public_token to your server
    // https://plaid.com/docs/api/tokens/#token-exchange-flow
    //console.log(publicToken, metadata);
    const sendPublicToken = async () => {
      const response = await authedRequestFn('plaid/accept_public_token', {
        method: 'POST',
        body: { userId, publicToken, metadata },
      })
      //console.log(response);
      options.onSuccess({ ...metadata, accounts: response })
    }
    sendPublicToken()
  }, [])

  return usePlaidLink({
    token, //: linkToken.data?.link_token || null,
    onSuccess,
    // onEvent
    // onExit
  })
}
